import { Tag } from 'antd'

import { PersonTransferRequestStatus } from 'src/api/requests'
import { useLocales } from 'src/locales'

type Props = {
  status: PersonTransferRequestStatus | null
}

export const transferStatusMap = {
  [PersonTransferRequestStatus.ACCEPTED]: 'success',
  [PersonTransferRequestStatus.NEW]: 'processing',
  [PersonTransferRequestStatus.PENDING]: 'warning',
  [PersonTransferRequestStatus.REJECTED]: 'error',
  [PersonTransferRequestStatus.TRANSFERRED]: 'success'
}

export const transferStatusColorMap = {
  [PersonTransferRequestStatus.ACCEPTED]: '#52c41a',
  [PersonTransferRequestStatus.NEW]: '#faad14',
  [PersonTransferRequestStatus.PENDING]: '#faad14',
  [PersonTransferRequestStatus.REJECTED]: '#ff4d4f',
  [PersonTransferRequestStatus.TRANSFERRED]: '#52c41a'
}

export const TransferStatusTag = ({ status }: Props) => {
  const { t } = useLocales()

  if (!status) return '-'

  return <Tag color={transferStatusMap[status]}>{t(`transfer.${status}`)}</Tag>
}
